/* Slide Collapse */
/********************************************************/
$('[data-toggle="slide-collapse"]').on('click', function () {
    if ($('.slide-collapse-overlay').length === 0) {
        var overlay = $('<div class="slide-collapse-overlay" />').appendTo('body');

        overlay.on('click', function (event) {
            $(".navbar-toggle").trigger("click");
            $(".slide-collapse-overlay").fadeOut(500);
        });
    }

    $navMenuCont = $($(this).data('target'));
    $navMenuCont.animate({
        'width': 'toggle'
    }, 350);

    $(".slide-collapse-overlay").fadeToggle(500);
});